import { Observable } from 'rxjs';
import { MallPublicModel, StorePublicModel } from '../models/store-public.model';


export abstract class StorePublicRepository {
    abstract getAll(): Observable<StorePublicModel[]>;
    abstract getAllMall(): Observable<MallPublicModel[]>;

}
